// The dashboards' texts in English, by key: the fallback, and how code
// written as t`English` (or t(label) for what the api answers) finds its key.
// The TextBundle "store_dashboards" translates them (useDashboardTexts); its
// translations are seeded by aldoo-com-api scripts/seed/vendor-portal-texts.js
// from vendor-portal-texts.json, where a new text gets the same key.
export default {
  marketing: "Marketing",
  campaign: "Campaign",
  ad: "Ad",
  keyword: "Keyword",
  sales_by_campaign: "Sales by campaign",
  sales_by_ad: "Sales by ad",
  sales_by_keyword: "Sales by keyword",
  which_campaign_brought_what_orders_customers_and_sales_of_ea: "Which campaign brought what: orders, customers and sales of each campaign in the period (utm_campaign; a Google Ads click without utm codes counts as google / cpc)",
  which_ad_brought_what_the_campaign_and_the_ad_utm_content_of: "Which ad brought what: the campaign and the ad (utm_content) of each sale in the period",
  which_keyword_brought_what_the_campaign_the_ad_and_the_keywo: "Which keyword brought what: the campaign, the ad and the keyword (utm_term) of each sale in the period",
  source_medium: "Source / medium",
  average_order: "Average order",
  share_of_net_sales: "Share of net sales",
  no_sales_in_this_period: "No sales in this period",
  adds_to_cart: "Adds to cart",
  units_added_to_cart: "Units added to cart",
  visitors_who_added_to_cart: "Visitors who added to cart",
  add_to_cart_placement: "Add-to-cart placement",
  add_to_cart_placements: "Add-to-cart placements",
  cart: "Cart",
  placement: "Placement",
  adds: "Adds",
  units: "Units",
  first_adds: "First adds",
  clicks: "\"+\" clicks",
  share: "Share",
  every_add_to_the_cart_and_every_wherever_on_the_: "Every add to the cart and every \"+\", wherever on the store front",
  where_on_the_store_front_products_are_added_to_t: "Where on the store front products are added to the cart: adds, units, first adds and \"+\" clicks, visitors, share of all adds",
  nothing_was_added_to_a_cart_in_this_period: "Nothing was added to a cart in this period",
  gross_sales: "Gross sales",
  processing_sales: "Processing sales",
  payment_type: "Payment type",
  cash_on_delivery: "Cash on delivery",
  paid_online: "Paid online",
  pay_at_the_shop: "Pay at the shop",
  processing_orders: "Processing orders",
  processing_sales_description: "Orders to be paid on delivery and not paid yet (not canceled): what their goods come to, by the day placed. They become Gross sales when the order is completed",
  processing_orders_description: "Orders to be paid on delivery and not paid yet (not canceled)",
  orders_awaiting_delivery: "Orders awaiting delivery",
  items_awaiting_delivery: "Items awaiting delivery",
  orders_awaiting_delivery_description: "Orders to be paid on delivery, not delivered and paid yet (not canceled). They count as Orders once completed",
  items_awaiting_delivery_description: "Units of your products in orders to be paid on delivery, not delivered and paid yet (not canceled). They count as Items sold once the order is completed",
  delivery_refunds: "Delivery refunds",
  n_filter: "%s filter",
  n_filters: "%s filters",
  n_of_n: "%s of %s",
  n_selected: "%s selected",
  n_more: "+%s more",
  all_n_s: "All %ss",
  cards_n: "Cards (%s)",
  days_are_counted_in_n: "Days are counted in %s",
  delete_n: "Delete \"%s\"?",
  top_n: "Top %s",
  by_n: "by %s",
  per_n: "per %s",
  vs_n: "vs %s",
  new_dashboard: "+ New dashboard…",
  a_line_for_each_of_the_biggest_without_the_earli: "A line for each of the biggest, without the earlier period",
  add_a_card: "Add a card",
  add_card: "Add card",
  add_filter: "Add filter",
  all: "All",
  apply: "Apply",
  bars: "Bars",
  cancel: "Cancel",
  chart: "Chart",
  clear: "Clear",
  clear_all: "Clear all",
  close: "Close",
  columns: "Columns",
  compare_to: "Compare to",
  could_not_load: "Could not load",
  create: "Create",
  customize: "Customize",
  customize_dashboard: "Customize dashboard",
  date_range: "Date range",
  default: "Default",
  delete: "Delete",
  delete_this_dashboard: "Delete this dashboard",
  drag_to_reorder: "Drag to reorder",
  edit_card: "Edit card",
  every_card_is_hidden: "Every card is hidden.",
  filter_by: "Filter by",
  filters: "Filters",
  hide_from_the_dashboard: "Hide from the dashboard",
  high_to_low: "High to low",
  it_starts_empty_add_the_cards_you_want_to_see: "It starts empty: add the cards you want to see.",
  less: "Less",
  line: "Line",
  lines: "Lines",
  loading_the_dashboard: "Loading the dashboard…",
  loading: "Loading…",
  low_to_high: "Low to high",
  metric: "Metric",
  name: "Name",
  new_dashboard_2: "New dashboard",
  nothing_here: "Nothing here",
  nothing_in_this_period: "Nothing in this period",
  nothing_matches_the_filters: "Nothing matches the filters",
  nothing_to_compare_with_all_time_has_no_period_b: "Nothing to compare with: all time has no period before it",
  nothing_one_line: "Nothing — one line",
  only_the_rows_that_match_every_filter: "Only the rows that match every filter",
  per: "Per",
  period: "Period",
  remove: "Remove",
  remove_card: "Remove card",
  remove_filter: "Remove filter",
  rows: "Rows",
  sales_overview: "Sales overview",
  save: "Save",
  segment_by: "Segment by",
  select: "Select",
  show: "Show",
  show_on_the_dashboard: "Show on the dashboard",
  show_them_from_customize: "Show them from Customize",
  size: "Size",
  sort: "Sort",
  sort_by: "Sort by",
  split_by: "Split by",
  table: "Table",
  the_biggest_first_past_the_count_below_the_rest: "The biggest first; past the count below, the rest as one",
  the_columns_the_card_shows: "The columns the card shows",
  the_dashboard_and_its_cards_go_the_figures_behin: "The dashboard and its cards go; the figures behind them stay.",
  the_dashboard_could_not_be_created: "The dashboard could not be created",
  the_date_range_folded_onto_it_which_hour_weekday: "The date range folded onto it: which hour, weekday or month the figure falls in",
  this_dashboard_has_no_cards_yet: "This dashboard has no cards yet.",
  time: "Time",
  title: "Title",
  you_have_the_most_dashboards_there_can_be: "You have the most dashboards there can be",
  hidden: "hidden",
  medium: "medium",
  small: "small",
  wide: "wide",
  the_dashboards_could_not_be_loaded: "The dashboards could not be loaded",
  the_figures_could_not_be_loaded: "The figures could not be loaded",
  number: "Number",
  segments: "Segments",
  one_figure_compared_with_the_earlier_period: "One figure, compared with the earlier period",
  a_metric_over_time_the_earlier_period_beside_it: "A metric over time, the earlier period beside it",
  rows_with_the_columns_sort_and_filters_you_choos: "Rows with the columns, sort and filters you choose",
  a_metric_by_hour_weekday_or_month_each_with_its: "A metric by time, device, payment or source, each group with its share",
  small_2: "Small",
  medium_2: "Medium",
  wide_2: "Wide",
  automatic: "Automatic",
  hour: "Hour",
  day: "Day",
  week: "Week",
  month: "Month",
  hour_2: "hour",
  day_2: "day",
  week_2: "week",
  month_2: "month",
  contains: "contains",
  is: "is",
  today: "Today",
  yesterday: "Yesterday",
  last_7_days: "Last 7 days",
  last_28_days: "Last 28 days",
  last_30_days: "Last 30 days",
  last_90_days: "Last 90 days",
  this_month: "This month",
  last_month: "Last month",
  this_year: "This year",
  last_year: "Last year",
  all_time: "All time",
  custom: "Custom",
  previous_period: "Previous period",
  next_period: "Next period",
  range_tab: "Range",
  quarter_tab: "Quarter",
  year_tab: "Year",
  same_period_last_year: "Same period last year",
  no_comparison: "No comparison",
  hour_of_the_day: "Hour of the day",
  day_of_the_week: "Day of the week",
  month_of_the_year: "Month of the year",
  sales: "Sales",
  refunds: "Refunds",
  traffic: "Traffic",
  catalog: "Catalog",
  orders: "Orders",
  products: "Products",
  merchants: "Merchants",
  other: "Other",
  net_sales: "Net sales",
  items_sold: "Items sold",
  average_order_value: "Average order value",
  items_per_order: "Items per order",
  customers: "Customers",
  refunded: "Refunded",
  items_refunded: "Items refunded",
  refund_rate: "Refund rate",
  discounts_given: "Discounts given",
  shipping_charged: "Shipping charged",
  product_views: "Product views",
  visitors: "Visitors",
  sessions: "Sessions",
  conversion_rate: "Conversion rate",
  products_available: "Products available",
  products_on_sale: "Products on sale",
  out_of_stock: "Out of stock",
  units_in_stock: "Units in stock",
  what_was_paid_for_your_products_before_refunds: "What was paid for your products, before refunds",
  sales_less_what_was_refunded_in_the_period: "Sales less what was refunded in the period",
  paid_orders_with_your_products: "Paid orders with your products",
  units_of_your_products_sold: "Units of your products sold",
  buyers_each_counted_once: "Buyers, each counted once",
  views_of_your_products_pages: "Views of your products' pages",
  devices_that_viewed_your_products_each_counted_o: "Devices that viewed your products, each counted once",
  items_sold_per_product_view: "Items sold per product view",
  products_a_buyer_can_order_now_on_sale_and_in_st: "Products a buyer can order now: on sale, and in stock or not stock-limited",
  every_product_in_the_catalog_whatever_its_state: "Every product in the catalog, whatever its state",
  published_and_switched_on_whatever_their_stock: "Published and switched on, whatever their stock",
  stock_limited_products_with_nothing_left: "Stock-limited products with nothing left",
  every_unit_left_of_the_stock_limited_products: "Every unit left of the stock-limited products",
  shipping_method: "Shipping method",
  shipping_provider: "Shipping provider",
  country: "Country",
  delivery: "Delivery",
  promo_code: "Promo code",
  checkout: "Checkout",
  traffic_source: "Traffic source",
  customer: "Customer",
  product: "Product",
  product_type: "Product type",
  category: "Category",
  author: "Author",
  merchant: "Merchant",
  to_an_address: "To an address",
  to_an_office: "To an office",
  to_a_locker: "To a locker",
  no_delivery: "No delivery",
  shipped: "Shipped",
  digital: "Digital",
  no_code: "No code",
  guest: "Guest",
  signed_in: "Signed in",
  direct: "Direct",
  stock: "Stock",
  waiting_to_ship: "Waiting to ship",
  promo_codes: "Promo codes",
  abandoned_carts: "Abandoned carts",
  countries: "Countries",
  your_products_that_sold_were_viewed_or_were_refu: "Your products that sold, were viewed or were refunded in the period, with what they did",
  products_at_or_below_a_stock_level_your_low_stoc: "Products at or below a stock level: your low stock threshold, or the card's own",
  the_orders_of_the_period: "The orders of the period",
  who_bought_in_the_period_their_orders_items_and: "Who bought in the period: their orders, items and money, and whether they bought before",
  paid_orders_with_a_parcel_still_to_send_oldest_f: "Paid orders with a parcel still to send, oldest first",
  each_refund_of_the_period_its_order_money_items: "Each refund of the period: its order, money, items and reason",
  the_codes_used_in_the_period_orders_customers_di: "The codes used in the period: orders, customers, discount given and the sales they brought",
  carts_started_in_the_period_and_never_paid_for_w: "Carts started in the period and never paid for, with your products in them",
  each_merchant_side_by_side_who_they_are_status_m: "Each merchant side by side: who they are (status, members, since when), their catalog, and their orders, sales, refunds and views in the period",
  your_catalog_by_product_type_as_it_stands_now_pr: "Your catalog by product type, as it stands now: products, on sale, available to buy, out of stock, units in stock",
  orders_and_sales_per_country: "Orders and sales per country",
  sku: "SKU",
  views: "Views",
  conversion: "Conversion",
  in_stock: "In stock",
  threshold: "Threshold",
  sold_in_period: "Sold in period",
  order: "Order",
  date: "Date",
  email: "Email",
  items: "Items",
  total: "Total",
  status: "Status",
  last_order: "Last order",
  new_or_returning: "New or returning",
  paid: "Paid",
  days_waiting: "Days waiting",
  to: "To",
  refund_of: "Refund of",
  reason: "Reason",
  code: "Code",
  discount: "Discount",
  last_touched: "Last touched",
  value: "Value",
  left: "Left",
  members: "Members",
  selling_since: "Selling since",
  available: "Available",
  on_sale: "On sale",
  stock_at_or_below: "Stock at or below",
  starts_at_the_company_s_low_stock_threshold: "Starts at the company's low stock threshold",
  nothing_waiting_to_ship: "Nothing waiting to ship",
  no_refunds_in_this_period: "No refunds in this period",
  no_promo_codes_used_in_this_period: "No promo codes used in this period",
  no_abandoned_carts_in_this_period: "No abandoned carts in this period",
  no_merchants_with_products: "No merchants with products",
  no_products_in_the_catalog: "No products in the catalog",
  returning: "Returning",
  new: "New",
  money_only: "Money only",
  left_in_the_cart: "Left in the cart",
  left_at_payment: "Left at payment",
  overview: "Overview",
  payment_method: "Payment method",
  not_recorded: "Not recorded",
  card: "Card",
  card_visa: "Card · Visa",
  card_mastercard: "Card · Mastercard",
  card_american_express: "Card · American Express",
  card_maestro: "Card · Maestro",
  purchases: "Purchases",
  items_purchased: "Items purchased",
  coins_spent: "Coins spent",
  paid_in_money: "Paid in money",
  every_purchase_of_your_products_on_the_web_and_i: "Every purchase of your products on the web and in the apps (iOS, Android, Windows), coins included",
  items_of_your_products_bought_on_the_web_and_in: "Items of your products bought on the web and in the apps",
  coins_buyers_spent_on_your_products_in_the_apps: "Coins buyers spent on your products in the apps and on the web",
  what_web_purchases_paid_in_money_in_app_purchase: "What web purchases paid in money; in-app purchases are paid through the app store, whose price is not recorded",
  platform: "Platform",
  // the Device dimension and its dashboard
  devices: "Devices",
  device: "Device",
  device_mobile: "Mobile",
  device_tablet: "Tablet",
  device_desktop: "Desktop",
  device_unknown: "Unknown",
  paid_with: "Paid with",
  purchase_type: "Purchase type",
  web: "Web",
  web_app: "Web (app)",
  coins: "Coins",
  money: "Money",
  app_store: "App store",
  web_order: "Web order",
  book_app: "Book (app)",
  coin_pack: "Coin pack",
  subscription: "Subscription",
  gift_card: "Gift card",
  as_it_stands_now: "As it stands now",
  app_coin_purchases: "App & coin purchases",
  your_products_bought_in_the_apps_ios_android_win: "Your products bought in the apps (iOS, Android, Windows) or with coins; web orders are counted in Orders and Sales",
  new_customers: "New customers",
  buyers_whose_first_order_of_your_products_was_in: "Buyers whose first order of your products was in the period",
  returning_customers: "Returning customers",
  buyers_in_the_period_who_had_bought_your_product: "Buyers in the period who had bought your products before it",
  retention_rate: "Retention rate",
  of_the_period_s_buyers_the_share_who_had_bought: "Of the period's buyers, the share who had bought your products before it",
  repeat_purchase_rate: "Repeat purchase rate",
  of_the_period_s_buyers_the_share_who_ordered_mor: "Of the period's buyers, the share who ordered more than once in it",
  customer_lifetime_value: "Customer lifetime value",
  what_the_period_s_buyers_have_spent_on_your_prod: "What the period's buyers have spent on your products in all, up to the end of the period, on average (LTV)",
  your_products_bought_in_the_apps_ios_android_win_2: "Your products bought in the apps (iOS, Android, Windows) or with coins — for the whole store also coin packs, subscriptions and gift cards; web orders are counted in Orders and Sales",
  shipped_method_not_recorded: "Shipped, method not recorded",
  shipped_courier_not_recorded: "Shipped, courier not recorded",
  courier_not_recorded: "Courier not recorded",
  code_redeemed: "Code redeemed",
  verified: "Verified",
  pending: "Pending",
  rejected: "Rejected",
  commission: "Commission",
  vendor_earnings: "Vendor earnings",
  commission_rate: "Commission rate",
  the_stores_commission_on_the_sales_of_the_period: "The store's commission on the sales of the period, each at its vendor's contract rate (the payouts ledger)",
  the_vendors_part_of_the_periods_sales: "The vendors' part of the period's sales: what was sold less the commission, plus the delivery the buyers paid",
  commission_as_a_share_of_net_sales: "Commission as a share of Net sales: the vendors' rates averaged by what each sold",
  what_was_paid_for_your_products_less_what_was_refunded_for_them: "What was paid for your products, less what was refunded for them in the period",
  money_given_back_in_the_period_for_goods: "Money given back in the period for goods (the delivery given back is Delivery refunds)",
  the_delivery_fee_given_back_in_the_period: "The delivery fee given back in the period",
  platform_earnings: "Platform earnings",
  platform_commission: "Platform commission",
  what_the_platform_made_in_the_period: "What the platform made in the period: its own company's net sales plus the commission on the other vendors' sales",
  the_commission_the_platform_earned_on_the_other_vendors_sales: "The commission the platform earned on the other vendors' sales in the period, each at its vendor's contract rate",
  // the vendor portal's ready-made dashboards: names, figures, tables
  visitors_conversion: "Visitors & conversion",
  when_people_buy: "When people buy",
  most_viewed_products: "Most viewed products",
  returned_parcels: "Returned parcels",
  returned_items: "Returned items",
  orders_the_courier_returned_to_you_refused_or_not_collected: "Orders the courier returned to you: refused or not collected, by the day they came back",
  units_of_your_products_in_the_parcels_the_courier_returned: "Units of your products in the parcels the courier returned",
  running_low: "Running low",
  products_on_sale_with_some_stock_left_at_or_below_your_low_s: "Products on sale with some stock left, at or below your low stock threshold",
  days_of_stock_left: "Days of stock left",
  how_long_the_stock_lasts_at_the_pace_it_sold_in_the_period_e: "How long the stock lasts at the pace it sold in the period: each product that sold, its units sold a day and the days its stock covers",
  sold_a_day: "Sold a day",
  days_left: "Days left",
  no_stock_limited_product_sold_in_this_period: "No stock-limited product sold in this period",
  not_selling: "Not selling",
  products_on_sale_that_sold_nothing_in_the_period_their_stock: "Products on sale that sold nothing in the period: their stock, their views and when they last sold",
  last_sold: "Last sold",
  every_product_on_sale_sold_in_this_period: "Every product on sale sold in this period",
  a_week_before: "A week before",
  // weekdays and months, short (a segments card's columns)
  weekday_mon: "Mon",
  weekday_tue: "Tue",
  weekday_wed: "Wed",
  weekday_thu: "Thu",
  weekday_fri: "Fri",
  weekday_sat: "Sat",
  weekday_sun: "Sun",
  month_jan: "Jan",
  month_feb: "Feb",
  month_mar: "Mar",
  month_apr: "Apr",
  month_may: "May",
  month_jun: "Jun",
  month_jul: "Jul",
  month_aug: "Aug",
  month_sep: "Sep",
  month_oct: "Oct",
  month_nov: "Nov",
  month_dec: "Dec",
  // win-back: the letters to the visitors who left a cart
  win_back: "Win-back",
  win_back_letters: "Win-back letters",
  letters_clicked: "Letters clicked",
  carts_won_back: "Carts won back",
  won_back_sales: "Won-back sales",
  gifts_given: "Gifts given",
  held_out_carts: "Held-out carts",
  click_rate: "Click rate",
  win_back_rate: "Win-back rate",
  comparison_group_rate: "Comparison group rate",
  uplift: "Uplift",
  win_back_step: "Win-back step",
  cart_reminder: "Cart reminder",
  suggestions: "Suggestions",
  letters_sent_to_visitors_who_left_a_cart: "Letters sent to visitors who left a cart",
  letters_whose_link_was_opened: "Letters whose link was opened",
  letters_followed_by_a_purchase_from_the_same_person_within_t: "Letters followed by a purchase from the same person within the attribution window",
  what_the_purchases_after_the_letters_came_to_a_company_its_o: "What the purchases after the letters came to (a company: its own products)",
  free_products_given_for_a_cart_completed_after_its_letter: "Free products given for a cart completed after its letter",
  left_carts_of_the_comparison_group_no_letter_to_see_what_the: "Left carts of the comparison group: no letter, to see what the letters add",
  letters_clicked_of_the_letters_sent: "Letters clicked, of the letters sent",
  letters_followed_by_a_purchase_of_the_letters_sent: "Letters followed by a purchase, of the letters sent",
  held_out_carts_whose_visitor_bought_anyway_of_the_held_out_c: "Held-out carts whose visitor bought anyway, of the held-out carts",
  win_back_rate_less_the_comparison_group_s_rate_the_purchases: "Win-back rate less the comparison group's rate: the purchases the letters brought (points)",
  the_letters_of_the_period_newest_first_the_step_the_comparis: "The letters of the period, newest first: the step, the comparison group's carts, the click, the purchase that followed and what it came to, the gift",
  no_win_back_letters_in_this_period: "No win-back letters in this period",
  step: "Step",
  group: "Group",
  clicked: "Clicked",
  won_back: "Won back",
  gift: "Gift",
  held_out: "Held out",
  sent: "Sent",
  payment: "Payment",
  awaiting_delivery: "Awaiting delivery",
  letters_followed_by_a_purchase_from_the_same_person_within_t_2: "Letters followed by a purchase from the same person within the attribution window (paid, or to be paid on delivery and not refused)",
  uplift_points: "Uplift (points)",
  // Admin → Store → Win-back
  s_item_s: "%s item(s)",
  s_letter_s_queued_each_goes_at_its_person_s_hour_within_a_da: "%s letter(s) queued: each goes at its person's hour within a day. The carts' log shows it.",
  s_of_s_cart_s_would_get_it: "%s of %s cart(s) would get it",
  s_pts: "%s pts",
  s_preview: "%s — preview",
  s_are_the_comparison_group_no_letter: "%s% are the comparison group (no letter)",
  s_of_the_left_carts_get_the_letters: "%s% of the left carts get the letters",
  n0_any_cart: "0: any cart",
  a_cart_keeps_its_group_the_comparison_group_s_carts_are_reco: "A cart keeps its group. The comparison group's carts are recorded with the moment they would have had their letter, so the results can compare what each group bought.",
  a_purchase_counts_as_won_back_within_days: "A purchase counts as won back within (days)",
  add_products: "Add products",
  and_never_two_in_a_day: "And never two in a day",
  at_most_given: "At most given",
  audience: "Audience",
  bought_since: "Bought since",
  cart_id_empty_the_latest_left_cart: "Cart (id; empty: the latest left cart)",
  carts_left_before_the_steps_ran_past_their_window_a_catch_up: "Carts left before the steps ran, past their window: a catch-up letter, once per person. The usual rules hold — bought since, offers off, the monthly limit, stock, the audience split — and each letter goes at its person's hour",
  carts_won_back_of_the_letters_sent_how_many_of_the_people_wr: "Carts won back, of the letters sent: how many of the people written to bought afterwards",
  could_not_load_the_settings: "Could not load the settings",
  could_not_read_the_carts: "Could not read the carts",
  could_not_save: "Could not save",
  could_not_send: "Could not send",
  days_after_the_cart_was_left: "Days after the cart was left",
  digital_products_only_they_go_to_the_buyer_s_library: "Digital products only: they go to the buyer's library",
  each_cart_gets_each_step_once_within_3_days_of_when_it_is_du: "Each cart gets each step once, within 3 days of when it is due",
  each_letter_goes_at_the_hour_the_person_is_likely_to_shop_in: "Each letter goes at the hour the person is likely to shop: in their time zone, the hour of day they ordered and acted on carts most (else the store's busiest hour), within the sending hours. No letter goes to someone who bought since, turned offers off in their profile (Privacy), has no address, or whose cart has a product that cannot be bought now.",
  empty_no_limit: "Empty: no limit",
  enter_a_whole_email_address: "Enter a whole email address",
  excluded: "Excluded",
  find_the_carts: "Find the carts",
  free_products: "Free products",
  free_products_put_in_buyers_libraries_given_when_the_order_t: "Free products put in buyers' libraries: given when the order that completed the very cart written about is paid",
  given: "Given",
  language: "Language",
  leave_out_these_addresses: "Leave out these addresses",
  left_more_than_days_ago: "Left more than (days ago)",
  letter: "Letter",
  letters_a_person_gets_in_30_days_at_most: "Letters a person gets in 30 days, at most",
  letters_followed_by_a_purchase_from_the_same_person_their_ac: "Letters followed by a purchase from the same person (their account or address) within the attribution window. A purchase to be paid on delivery counts once placed, and stops counting if the parcel is refused or returned. An order counts for one letter only: the latest before it",
  letters_sent: "Letters sent",
  letters_to_the_visitors_who_left_a_cart_a_reminder_products: "Letters to the visitors who left a cart: a reminder, products like it later, a product free when they complete it",
  monthly_limit: "Monthly limit",
  no_address: "No address",
  no_end: "No end",
  no_free_products_the_letters_offer_none: "No free products: the letters offer none",
  no_left_carts_in_that_range: "No left carts in that range",
  no_limit: "No limit",
  no_preview: "No preview",
  no_product_of_this_cart_or_like_it_is_in_stock: "No product of this cart (or like it) is in stock",
  not_before_this_hour: "Not before this hour",
  not_from_this_hour_on: "Not from this hour on",
  nothing_in_stock_to_show: "Nothing in stock to show",
  of_the_left_carts_held_out_no_letter_the_part_of_the_audienc: "Of the left carts held out (no letter — the part of the audience slider not written to), the share whose visitor bought anyway. With the audience at 100% there is no comparison group, and this stays 0",
  of_the_letters_sent_the_share_whose_link_was_opened_the_butt: "Of the letters sent, the share whose link was opened (the button, or a product in it)",
  off: "Off",
  offer_a_free_product: "Offer a free product",
  offered_until: "Offered until",
  offers_off: "Offers off",
  older_carts: "Older carts",
  on: "On",
  only_for_carts_of_at_least_eur: "Only for carts of at least (EUR)",
  ours_demo_accounts_one_per_line_or_separated_by_commas: "Ours, demo accounts: one per line, or separated by commas",
  outcome: "Outcome",
  preview: "Preview",
  products_in_the_letter: "Products in the letter",
  products_like_the_ones_in_the_cart_its_type_category_author: "Products like the ones in the cart (its type, category, author), in stock, for a visitor who did not come back",
  reading: "Reading…",
  rendering: "Rendering…",
  results: "Results",
  same_person: "Same person",
  saved: "Saved",
  saving: "Saving…",
  send_a_test: "Send a test",
  send_from_the_reader_s_time_zone: "Send from (the reader's time zone)",
  send_the_s_letter_to_s_person_s: "Send the %s letter to %s person(s)?",
  send_the_test_to_empty_your_own_address: "Send the test to (empty: your own address)",
  send_to_s: "Send to %s",
  sending: "Sending",
  sending_2: "Sending…",
  sent_to_s: "Sent to %s",
  steps: "Steps",
  store_bot: "Store bot",
  suggestions_products_like_the_cart_s: "Suggestions (products like the cart's)",
  the_win_back_dashboard: "The Win-back dashboard",
  the_cart_a_few_days_after_it_was_left_with_a_product_free_wh: "The cart, a few days after it was left — with a product free when the order is completed, if you turn the gift on",
  the_win_back_rate_less_the_comparison_group_s_rate_in_percen: "The win-back rate less the comparison group's rate, in percentage points: the purchases the letters brought beyond those that would have happened anyway. +5 pts: 5 more purchases per 100 carts written to. It needs a comparison group (audience under 100%) and a few weeks of carts to mean much",
  there_is_no_left_cart_to_show_it_with: "There is no left cart to show it with",
  to_the_reader_s_time_zone: "To (the reader's time zone)",
  up_to_days_ago: "Up to (days ago)",
  what_a_letter_offers_free_when_its_cart_is_completed_the_fir: "What a letter offers free when its cart is completed: the first on the list the buyer does not own and the cart does not hold. Digital products only: given into their library once the order is paid",
  what_is_s: "What is %s?",
  what_the_letters_brought_in_the_period_the_comparison_group: "What the letters brought in the period. The comparison group's carts got no letter: the uplift is what the letters added",
  what_the_purchases_after_the_letters_came_to_each_line_s_pri: "What the purchases after the letters came to: each line's price less its share of any promo code, delivery not included. Parcels refused or returned are taken off",
  who_gets_the_letters_how_often_and_when: "Who gets the letters, how often, and when",
  will_get_it: "Will get it",
  win_back_letters_are_off: "Win-back letters are off",
  win_back_letters_are_sent: "Win-back letters are sent",
  win_back_letters_sent_in_the_period_cart_reminders_suggestio: "Win-back letters sent in the period: cart reminders, suggestions and older-cart catch-ups. The comparison group's carts are not counted here",
  gift_2: "gift",
  subject: "subject",
  bought_since_2: "bought since",
  no_address_to_write_to: "no address to write to",
  a_store_bot_s_address: "a store bot's address",
  offers_turned_off: "offers turned off",
  excluded_2: "excluded",
  a_later_cart_of_the_same_person_gets_it: "a later cart of the same person gets it",
  no_product_like_it_in_stock: "no product like it in stock",
  the_suggestions_letter_at_their_hour: "the suggestions letter, at their hour",
  the_cart_reminder_letter_at_their_hour: "the cart reminder letter, at their hour",
  a_product_of_the_cart_cannot_be_bought_now: "a product of the cart cannot be bought now",
  abandoned: "abandoned",
  expired: "expired",
  what_a_letter_offers_free_when_its_cart_is_completed_of_the: "What a letter offers free when its cart is completed: of the products the buyer does not own and the cart does not hold, the one most like the cart (author, category, type); alike or none alike, the first in this order — drag to change it. Digital products only: given into their library once the order is paid",
  n_without_an_address_left_out: "%s without an address left out",
  send_the_catch_up_letters: "Send the catch-up letters?",
  queued: "Queued",
  goes_at_their_hour_within_a_day: "goes at their hour within a day",
  could_not_clear_the_queue: "Could not clear the queue",
  s_cart_s_taken_out_of_the_queue: "%s cart(s) taken out of the queue",
  clear_the_queue: "Clear the queue?",
  s_queued_letter_s_will_not_be_sent_the_carts_can_be_queued_a: "%s queued letter(s) will not be sent. The carts can be queued again.",
  clear_the_queue_2: "Clear the queue",
  queue_s: "Queue (%s)",
  queue: "Queue",
  catch_up_letters_waiting_for_their_person_s_hour_none_goes_i: "Catch-up letters waiting for their person's hour (none goes in the quiet hours). Take one out, or clear them all",
  nothing_queued: "Nothing queued",
  left_2: "left",
  take_out_of_the_queue: "Take out of the queue",
  s_letter_s_taken_out_of_the_queue: "%s letter(s) taken out of the queue",
  s_queued_letter_s_will_not_be_sent_the_older_carts_can_be_qu: "%s queued letter(s) will not be sent. The older carts can be queued again.",
  every_letter_waiting_to_go_the_steps_carts_left_and_due_now: "Every letter waiting to go: the steps' (carts left and due now or in the next two days) and the older carts' catch-ups. Each goes at its person's hour, and the rules are checked then — bought since, offers off, stock, the monthly limit, the audience split",
  refresh: "Refresh",
  win_back_is_off_the_steps_letters_wait_until_it_is_on_sendin: "Win-back is off: the steps' letters wait until it is on (Sending). The older carts' catch-ups go anyway.",
  due: "Due",
  now_at_their_hour: "now, at their hour",
  older_cart: "Older cart",
  s_letter_s_queued_each_goes_at_its_person_s_hour_within__2: "%s letter(s) queued: each goes at its person's hour within a day. See them in the Queue tab.",
}
